import React, { useEffect, useMemo } from 'react';
import FileUploaderWithCropTool from 'components/base/file-uploader/crop-tool';
import useGetStartedActionsContext from 'contexts/get-started-actions.context';
import { Input } from '@cokitchen/cokitchen-components';
import SelectDropdown from 'components/base/select-dropdown';
import useAxios from 'hooks/useAxios';
import { CokitchenFCBBrandResponse } from 'models/brand-details.model';

const AddBrand = () => {
  const { brandFormData, setBrandFormData, setIsDisabled } = useGetStartedActionsContext();

  const { fetchData, response: FCBBrandType } = useAxios<CokitchenFCBBrandResponse>({
    url: 'company/cokitchen'
  });

  useEffect(() => {
    setIsDisabled(!brandFormData.name || !brandFormData.images[0]);
  }, [brandFormData]);

  useEffect(() => {
    fetchData();
  }, []);

  const setBrandLogo = (data: string[]) => {
    setBrandFormData({ ...brandFormData, images: data });
  };

  //---- selected brand type and it's listing-----
  const FCBBrandTypeOptions = useMemo(
    () =>
      FCBBrandType?.data?.data?.map((fcb) => ({ id: fcb?.id, name: fcb?.name })) ?? [
        {
          id: '',
          name: 'N/A'
        }
      ],
    [FCBBrandType]
  );

  const selectedFCBBrandTypeObj = FCBBrandType?.data?.data?.find(
    (fcb) => fcb?.id === brandFormData?.cokitchen_id
  );

  return (
    <div className='flex flex-col max-w-[390px] w-full mx-auto'>
      <h2 className='text-2xl font-bold'>Add brand details</h2>
      <p className='text-[#6F7376] text-sm mt-2 mb-10'>
        Personalise your orders by naming the brand that caters to your business
      </p>
      <div className='flex flex-col gap-7'>
        <Input
          design='bordered'
          type='text'
          label='Brand name'
          name='brand_name'
          value={brandFormData.name}
          onChange={(e) => setBrandFormData({ ...brandFormData, name: e.target.value })}
          placeholder='e.g FCBkitchen'
        />
        <div>
          <p className='mb-[6px] text-[#2E3031] font-medium'>Brand image</p>
          <FileUploaderWithCropTool
            aspectRatio={16 / 9}
            fileUrls={brandFormData.images}
            setFileUrls={setBrandLogo}
          />
        </div>

        <SelectDropdown
          label=' Select CoKitchen'
          value={selectedFCBBrandTypeObj?.name}
          setValue={(option) => {
            setBrandFormData({ ...brandFormData, cokitchen_id: option?.id });
          }}
          placeholder='Choose a Cokitchen'
          options={FCBBrandTypeOptions}
        />
      </div>
    </div>
  );
};

export default AddBrand;
